import { useQuery } from '@tanstack/react-query'
import { Alert, Button, Select } from 'antd'
import { useTRPC } from '@/trpc/react.ts'
import { formatAccountLabel } from './utils/account-label.ts'

export function OrganizationAccountSelect({
  organizationId,
  purpose,
  value,
  onChange,
  id
}: {
  id?: string
  purpose: 'bill.group.read' | 'bill.receipt.record' | 'bill.payment.record' | 'bill.refund.record'
  organizationId: number
  value?: number
  onChange?: (value: number | undefined) => void
}) {
  const trpc = useTRPC()
  const query = useQuery(trpc.bill.accounts.queryOptions({ organizationId, purpose }))
  const accounts = query.data?.filter((account) => account.isEnabled) ?? []
  let emptyMessage = '该经营主体暂无启用的账户'
  if (query.isPending) {
    emptyMessage = '正在加载账户…'
  } else if (query.isError) {
    emptyMessage = '账户加载失败，请重试'
  }
  return (
    <div>
      <Select
        id={id}
        className="w-full"
        value={value}
        onChange={onChange}
        allowClear
        showSearch={{ optionFilterProp: 'label' }}
        placeholder="请选择经营主体的账户"
        loading={query.isFetching}
        notFoundContent={emptyMessage}
        options={accounts.map((account) => ({ value: account.id, label: formatAccountLabel(account) }))}
      />
      {query.isError && <Alert className="mt-2" type="error" title={query.error.message} />}
      {query.isSuccess && !accounts.length && (
        <Alert
          className="mt-2"
          type="warning"
          showIcon
          title="该经营主体尚未配置可用的收付款账户"
          description="请在经营主体的「收付款账户」中添加或启用账户，保存后点击刷新。无维护权限时请联系管理员。"
        />
      )}
      <div className="mt-1 flex gap-2">
        <Button
          type="link"
          href={`/master-data/legal-entities/${organizationId}/edit#section-payment`}
          target="_blank"
          rel="noopener noreferrer"
        >
          维护主体收付款账户
        </Button>
        <Button type="link" loading={query.isFetching} onClick={() => void query.refetch()}>
          刷新账户
        </Button>
      </div>
    </div>
  )
}
